module.exports = __webpack_public_path__ + "static/img/14000539.b4ef524b.png";